module.exports = __webpack_public_path__ + "img/type_pdf.22673138.svg";